import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import styles from "./AttendanceRoom.module.css"

import RowData from "../../components/RowData/RowData";
import ToClose from "../../components/ToClose/ToClose";

const AttendanceRoom = ({ isOpen, data }) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Students");

  if (!isOpen) return null;

  const currentData = data?.[activeTab] || [];

  const inLabel = activeTab === "Students" ? "Students In" : "Staff In";
  const outLabel = activeTab === "Students" ? "Students Out" : "Staff Out";

  return (
    <div className={styles.background}>
      <div className={styles.ModalOverlay}>
        <div className={styles.ModalContent}>
          {/* Use the reusable close button */}

          {/* Tab selector inside modal */}
          <div className={styles.ModalTabSelector}>
            <div className={styles.leftsideselector}>
              <button
                className={`${styles.TabButton} ${
                  activeTab === "Students" ? styles.ActiveTab : ""
                }`}
                onClick={() => setActiveTab("Students")}
              >
                Students
              </button>
              <button
                className={`${styles.TabButton} ${
                  activeTab === "Staff" ? styles.ActiveTab : ""
                }`}
                onClick={() => setActiveTab("Staff")}
              >
                Staff
              </button>
            </div>
            <div className={styles.rightsideclose}>
              <ToClose onClose={() => dispatch(closeModal())} />
            </div>
          </div>

          {/* Data Table */}
          <div className={styles.DetailsTableContainer}>
            <div className={styles.TableHeader}>
              <div className={styles.TableHeaderColorContainer}>
                <span>Room Name</span>
                <span>{inLabel}</span>
                <span>{outLabel}</span>
                <span>Pending</span>
              </div>
            </div>
            <div className={styles.DataRows}>
              {currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <RowData
                    key={index}
                    room={item.room}
                    inCount={item.in}
                    outCount={item.out}
                    pendingCount={item.pending}
                  />
                ))
              ) : (
                <div
                  style={{
                    padding: "1rem",
                    textAlign: "center",
                    color: "gray",
                  }}
                >
                  No {activeTab.toLowerCase()} data available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceRoom;
